import React from 'react'
import { Tag as ChakraTag, TagCloseButton } from '@chakra-ui/react'
import { HubStyleObject } from '@hub/design-system-base'
import { Box } from '@hub/box'

const colors = {
  licorice: {
    bg: 'licorice',
    text: 'white',
  },
  ghost: {
    bg: 'ghost',
    text: 'licorice',
  },
  surfacePrimary: {
    bg: 'surfacePrimary',
    text: 'textSurfacePrimary',
  },
  surfaceBrandSecondary: {
    bg: 'surfaceBrandSecondary',
    text: 'textPrimary',
  },
} as const

const variants = {
  default: {
    padding: 'spacing-xs',
    paddingLeft: 'spacing-md',
    paddingRight: 'spacing-md',
    fontWeight: 'normal',
    rounded: 'xl',
  },
  full: {
    padding: 'spacing-md',
    fontWeight: 'normal',
    rounded: 'full',
    lineHeight: 'none',
  },
} as const

export type HubPillVariants = keyof typeof variants

export interface PillProps {
  colorScheme?: keyof typeof colors
  sx?: HubStyleObject
  variant?: HubPillVariants
  flexGrow?: number
  ariaLabel?: string
  onClose?: () => void
}

const WithFlexBox = ({
  flexGrow,
  children,
}: {
  flexGrow?: number
  children: JSX.Element
}): JSX.Element =>
  flexGrow !== undefined ? <Box sx={{ flexGrow }}>{children}</Box> : children

export const Pill: React.FC<React.PropsWithChildren<PillProps>> = ({
  colorScheme = 'licorice',
  onClose,
  children,
  sx,
  variant = 'default',
  flexGrow,
  ariaLabel,
}) => {
  const colorPalette = colors[colorScheme] || colors.licorice
  const variantProps = variants[variant] || variants['default']

  return (
    <WithFlexBox flexGrow={flexGrow}>
      <ChakraTag
        backgroundColor={colorPalette.bg}
        color={colorPalette.text}
        fontSize="font-md"
        sx={{
          textWrap: 'nowrap',
          justifyContent: 'center',
          ...sx,
        }}
        {...variantProps}
      >
        {children}
        {onClose && <TagCloseButton aria-label={ariaLabel} onClick={onClose} />}
      </ChakraTag>
    </WithFlexBox>
  )
}
